import api from "../../../index";

// Create copilot
export const createCopilot = async (data: any) => {
  return await api.post("/copilot", data);
};

// Get all copilots
export const getAllCopilots = async () => {
  return await api.get("/copilots");
};

// Get all copilots paginated search
export const getAllCopilotsPaginatedSearch = async (
  page: any,
  perPage: any,
  searchText: any
) => {
  if (!searchText) {
    return await api.get(
      `/copilots/paginated/search?page=${page}&perPage=${perPage}`
    );
  } else {
    return await api.get(
      `/copilots/paginated/search?page=${page}&perPage=${perPage}&searchText=${searchText}`
    );
  }
};

// Get copilot by id
export const getCopilotById = async (id: any) => {
  return await api.get(`/copilot/${id}`);
};

// Update copilot by id
export const updateCopilotById = async (id: any, data: any) => {
  return await api.put(`/copilot/${id}`, data);
};

// Delete copilot by id
export const deleteCopilotById = async (id: any) => {
  return await api.delete(`/copilot/${id}`);
};

// Upload copilot image
export const uploadCopilotImage = async (values: any, config: any) => {
  return await api.post("/copilot/image", values, config);
};
